var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalSwimmersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 85,
    viewBox: "0 0 84 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_367_1662)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.000976562,
    width: 84,
    height: 85,
    rx: 5,
    fill: "#FCEBE3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_367_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2771 38.5534C56.2771 41.5047 53.884 43.8982 50.9323 43.8982C47.9816 43.8982 45.5889 41.5047 45.5889 38.5534C45.5889 35.602 47.982 33.21 50.9323 33.21C53.8843 33.21 56.2771 35.602 56.2771 38.5534Z",
    fill: "#ED7847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9374 49.8979C44.2356 49.7394 47.1676 48.2607 43.8379 42.989L40.9632 36.187C40.2861 34.5863 40.2235 33.2279 40.7706 32.0343C41.7838 29.8248 44.7531 28.4582 45.8127 28.1158C47.1785 27.6862 47.9386 26.2307 47.5114 24.8625C47.0843 23.4924 45.626 22.7292 44.2552 23.156C43.6449 23.3451 38.2312 25.1497 36.0607 29.8297C34.8861 32.3592 34.9255 35.2585 36.1732 38.2123L36.4238 38.8058L20.8792 47.8132C20.8792 47.8132 34.4723 54.9443 43.9374 49.8979Z",
    fill: "#ED7847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0491 50.293C18.0491 50.293 24.5097 55.3098 34.2579 55.3098C44.006 55.3098 44.3459 51.2299 49.7308 51.2299C55.1147 51.2299 63.0491 56.2165 63.0491 56.2165C63.0491 56.2165 59.0666 52.2407 43.6569 59.9807C28.2472 67.7207 18.0491 50.293 18.0491 50.293Z",
    fill: "#ED7847"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_367_1662",
    x: -0.000976562,
    y: 0,
    width: 84,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.0941176 0 0 0 0 0.164706 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_367_1662"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_1662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(18.999 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSwimmersIcon);
export default __webpack_public_path__ + "static/media/totalSwimmersIcon.9124e20c94634b8c38fc1ea091adafb4.svg";
export { ForwardRef as ReactComponent };